import { render, staticRenderFns } from "./FilesPortlet.vue?vue&type=template&id=59c4b8f2&"
import script from "./FilesPortlet.vue?vue&type=script&lang=js&"
export * from "./FilesPortlet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports